import React, { useEffect, useState } from "react";
import DataTable from "react-data-table-component";
import axios from "axios";
import { API_BASE_URL } from "../../config";

const TicketLogs = ({ ticketId, getAuthHeader }) => {
  const [logs, setLogs] = useState([]);
  const [search, setSearch] = useState("");

  const loadLogs = async () => {
    try {
      const res = await axios.get(
        `${API_BASE_URL}/tickets/${ticketId}/logs`,
        { headers: getAuthHeader() }
      );
      setLogs(Array.isArray(res.data) ? res.data : []);
    } catch (err) {
      console.error("Log load error:", err);
      setLogs([]);
    }
  };

  useEffect(() => {
    loadLogs();
  }, [ticketId]);

  const filteredLogs = logs.filter((row) =>
    Object.values(row).some((v) =>
      String(v).toLowerCase().includes(search.toLowerCase())
    )
  );

  /* 🔹 COMPACT & RESPONSIVE STYLES */
  const customStyles = {
    table: {
      style: {
        width: "100%",
      },
    },
    headRow: {
      style: {
        minHeight: "32px",
      },
    },
    rows: {
      style: {
        minHeight: "30px",
      },
    },
    headCells: {
      style: {
        padding: "6px",
        fontSize: "12px",
        fontWeight: "600",
        whiteSpace: "nowrap",
      },
    },
    cells: {
      style: {
        padding: "6px",
        fontSize: "12px",
      },
    },
  };

  /* 🔹 WELL-BALANCED COLUMNS */
  const columns = [
    {
      name: "Reported By",
      selector: (row) => row.reported_by,
      wrap: true,
      minWidth: "180px",
      grow: 1,
      sortable: true,          
    },
    {
      name: "Priority",
      selector: (row) => row.priority,
      center: true,
      minWidth: "90px",
      maxWidth: "110px",
      sortable: true,          
    },
    {
      name: "Status",
      selector: (row) => row.status,
      center: true,
      minWidth: "90px",
      maxWidth: "110px",
      sortable: true,          
    },
    {
      name: "Remarks",
      selector: (row) => row.resolution,
      wrap: true,
      minWidth: "420px",
      grow: 1,
      sortable: true,          
    },
    {
      name: "Assign",
      selector: (row) => row.assign,
      wrap: true,
      minWidth: "160px",
      grow: 1,
    },
  ];

  return (
    <div className="card p-2">
      <div className="d-flex justify-content-between align-items-center mb-2">
        <h5 className="mb-0">Logs</h5>

        {/* 🔍 SEARCH (RIGHT, SMALL) */}
        <input
          type="text"
          placeholder="Search..."
          className="form-control form-control-sm"
          style={{ width: "180px" }}
          value={search}
          onChange={(e) => setSearch(e.target.value)}
        />
      </div>

      <DataTable
        columns={columns}
        data={filteredLogs}
        dense
        striped
        highlightOnHover
        customStyles={customStyles}
        pagination
        responsive
        noHeader
        noDataComponent="No logs found"
      />
    </div>
  );
};

export default TicketLogs;
